import { useContext } from "react";
import {
  Avatar,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";
import { BiImage } from "react-icons/bi";
import { FirmaElectronicaContext } from "../context/firmaElectronicaContext";
import { ListaFirmante } from "./listaFirmante";
import { eliminarRepetidosPorAtributo } from "utils/_generals";

export const Firmantes = () => {
  const { statusFirma } = useContext(FirmaElectronicaContext);

  const missing = eliminarRepetidosPorAtributo(
    statusFirma?.missing[0]?.data || [],
    "nombreFirmante"
  );

  const signed = eliminarRepetidosPorAtributo(
    statusFirma?.signed[0]?.data || [],
    "nombreFirmante"
  );

  return (
    <List sx={{ width: "100%", bgcolor: "background.paper" }}>
      <Typography variant="h6" className="text-center py-3">
        Lista Firmantes
      </Typography>
      <Divider />
      {statusFirma?.signed?.length && statusFirma?.signed[0]?.data?.length ? (
        signed.map((firmante: any) => (
          <ListaFirmante firmante={firmante} key={firmante.idRegistroFirma} />
        ))
      ) : !statusFirma?.missing?.length ? (
        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <BiImage />
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary="Sin firmantes que mostrar" />
        </ListItem>
      ) : !statusFirma?.missing[0]?.data.length ? (
        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <BiImage />
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary="Sin firmantes que mostrar" />
        </ListItem>
      ) : (
        missing.map((firmante) => (
          <ListaFirmante firmante={firmante} key={firmante.idRegistroFirma} />
        ))
      )}
    </List>
  );
};
